/** Returns an array with only distinct items from the original array. ``predicate`` should return a hash/id value for every element in the array. You can return undefined to exclude the item from the final array. */
export function distinct<T>(
  arr: T[],
  predicate: (src: T) => string | undefined,
) {
  const searchMap = Object.create(null);
  const distinctArray: T[] = [];
  for (const src of arr) {
    const key = predicate(src);
    if (key === undefined || key in searchMap) {
      continue;
    }
    searchMap[key] = true;
    distinctArray.push(src);
  }
  return distinctArray;
}
